import React from "react";

import DialogActions from "@busbud/design-system-components/dist/DialogActions";

import type { ErrorModalButtonType } from "@app/helpers/api-error";

import type { ButtonType, ButtonConfig } from "./alert-button";

import { AlertButton, BUTTON_TYPES } from "./alert-button";

type CancelDialogFooterProps = {
  handleButtonClick: (
    button_type: ErrorModalButtonType,
    action_name?: ButtonType
  ) => void;
  cta_button_config?: ButtonConfig;
  primary_button_config?: ButtonConfig;
  secondary_button_config?: ButtonConfig;
};

export const CancelDialogFooter: React.FC<CancelDialogFooterProps> = props => {
  const {
    cta_button_config,
    primary_button_config,
    secondary_button_config,
    handleButtonClick
  } = props;

  if (
    !cta_button_config &&
    !primary_button_config &&
    !secondary_button_config
  ) {
    return null;
  }

  return (
    <DialogActions direction="horizontal">
      <AlertButton
        // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
        type={BUTTON_TYPES.SECONDARY}
        config={secondary_button_config}
        onClick={handleButtonClick}
      />
      <AlertButton
        // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
        type={BUTTON_TYPES.PRIMARY}
        config={primary_button_config}
        onClick={handleButtonClick}
      />
      <AlertButton
        // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
        type={BUTTON_TYPES.CALL_TO_ACTION}
        config={cta_button_config}
        onClick={handleButtonClick}
      />
    </DialogActions>
  );
};
